import { render } from "./modall-add-penilai.vue?vue&type=template&id=13385a1c&scoped=true"
import script from "./modall-add-penilai.vue?vue&type=script&lang=js"
export * from "./modall-add-penilai.vue?vue&type=script&lang=js"

import "./modall-add-penilai.vue?vue&type=style&index=0&id=13385a1c&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13385a1c"]])

export default __exports__